import { useHead } from '@unhead/react';
import { useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { SingleCardPageWithFilterCardLayout } from 'business/layout/single-card-page-with-filter-card';
import { QualityControlPrintHeader } from 'business/quality-control/components/quality-control-print-header';

import { RingComplianceDetailContainer } from './components/ring-compliance-detail-container';
import styles from './index.module.scss';

export function RingComplianceReportDetailPage() {
  const { ringId } = useParams<{ ringId: string }>();
  invariant(ringId, 'Missing ringId');

  const { currentConstructionSiteId } = useAppContext();
  invariant(currentConstructionSiteId, 'Missing currentConstructionSiteId');

  const { t } = useTranslation();

  useHead({
    title: t('qualityControl.ringComplianceReport.detail.title'),
  });

  return (
    <div className={styles.printContainer}>
      <SingleCardPageWithFilterCardLayout
        title={t('qualityControl.ringComplianceReport.detail.title')}
        printHeader={
          <QualityControlPrintHeader
            printTitle={t('qualityControl.ringComplianceReport.detail.title')}
          />
        }
      >
        <RingComplianceDetailContainer ringId={ringId} />
      </SingleCardPageWithFilterCardLayout>
    </div>
  );
}
